import { helper as buildHelper } from '@ember/component/helper';
export default buildHelper(function (value, options) {
  if (value[0]) {
    let regexp = new RegExp(options.replace, 'g');
    return value[0].toString().replace(regexp, options.replaceWith);
  }

  return '';
});
